import { render, staticRenderFns } from "./Cesion.vue?vue&type=template&id=71b79960&scoped=true"
import script from "./Cesion.vue?vue&type=script&lang=js"
export * from "./Cesion.vue?vue&type=script&lang=js"
import style0 from "./Cesion.vue?vue&type=style&index=0&id=71b79960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b79960",
  null
  
)

export default component.exports